import { put } from '../utils/communication/api';

type UpdateTenantAttributeRequest = {
  propertyKey: string;
  propertyValue: string | null;
};

export const updateTenantAttribute = async (propertyKey: string, propertyValue: string | null) => {
  const request: UpdateTenantAttributeRequest = {
    propertyKey: propertyKey,
    propertyValue: propertyValue
  };
  await put<unknown, UpdateTenantAttributeRequest>('/api-internal/tenant-attribute', request, true);
};
